import CommonNotificationListItem from './CommonNotificationListItem'

export default CommonNotificationListItem
